import React from 'react';
import Script from 'react-load-script';
import { inject } from 'mobx-react';
import ReactDOM from 'react-dom';

import { DEVICE_FINGERPRINT_URL, DEVICE_FINTERPRINT_ORG_ID } from '~/common/utils/consts';

const scriptsContainer = document.getElementById('scripts-container');
@inject('flexFrameStore')
export default class FingerPrint extends React.Component {
    constructor(props) {
        super(props);
        this.el = document.createElement('div');
        // create unique id
        this.props.flexFrameStore.getFingerPrintID();
    }

    componentDidMount() {
        scriptsContainer.appendChild(this.el);
    }

    componentWillUnmount() {
        scriptsContainer.removeChild(this.el);
    }

    renderElements() {
        const { FingerPrintID } = this.props.flexFrameStore;
        const url = `${DEVICE_FINGERPRINT_URL}tags.js?org_id=${DEVICE_FINTERPRINT_ORG_ID}&session_id=grasshopper${FingerPrintID}`;
        const iframeStyles = {
            width: '100px',
            height: '100px',
            border: '0',
            position: 'absolute',
            top: '-5000px'
        };
        return (
            <React.Fragment>
                <Script url={url} />
                <noscript>
                    <iframe src={url} style={iframeStyles}></iframe>
                </noscript>
            </React.Fragment>
        );
    }
    render() {
        // render using a portal to avoid elements being added possibly breaking the site design
        return ReactDOM.createPortal(
            this.renderElements(),
            this.el
        );
    }
}
